/**<params config data>说明
 * position 控制文本框宽度位置
 */
import css from './index.module.scss';
import TextBanner from '@/componentsH5/ProductDetailComponents/TextBanner';
import { createEFPic } from '@/utils/useEFPic';
import Image from '@/components/UI/Image';

const item = {
    title: 'Battery Management System',
    synopsis: 'Performance plus safety.',
    desc: 'Confidence comes when you know your battery can take care of its own. The battery management system self regulates to keep your portable power station performing its best when it’s pushed to the limit.',
    bgImgs: '/img/rivermax2.png',
    alt: '',
};
const configs = {
    position: 'left',
    margin: 'auto',
    padding: '0',
    zIndex: 2,
};
export default function TextOnImage({ config, data = item }: any) {
    const configTypes = { ...configs, ...config };
    const { EFPic } = createEFPic(configTypes?.webpUrl);
    if (!configTypes.imgHeight) {
        configTypes.imgHeight = configTypes.position === 'left' || configTypes.position === 'right' ? '4rem' : '5.4rem';
    }

    return (
        <div className={css.TextOnImage}>
            <div className="box" key={data.title} style={{ height: configTypes.imgHeight }}>
                <div className="bg signFullImgsBox">
                    {Array.isArray(data.bgImgs) ? (
                        <EFPic name={data.bgImgs} alt={data.title ? data.title : data.synopsis} />
                    ) : (
                        <Image src={data.bgImgs} layout="fill" alt={data.title ? data.title : data.synopsis} />
                    )}
                </div>
                <div
                    className={
                        configTypes.position == 'top'
                            ? 'container topPosition'
                            : configTypes.position == 'left'
                            ? 'container leftPosition'
                            : configTypes.position == 'right'
                            ? 'container rightPosition'
                            : 'container bottomPosition'
                    }
                >
                    <TextBanner config={configTypes} data={data} />
                </div>
            </div>
        </div>
    );
}
